import { type SVGProps } from "react";

export default function ChCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="275"
      height="153"
      viewBox="0 0 275 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      {...props}
    >
      <path
        d="M229.881 0L178.119 85.0015L47.9392 1.55301L0 80.2389L199.299 208L202.502 202.823L247.238 129.314L299 44.3126L229.881 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
